import axios from 'axios'
import { Baseurl } from '../../constants/env'
import { spinerLog } from '../../features/spinner'
import { dispatch } from '../../features/store'
axios.defaults.withCredentials = false
const unInterceptedAxiosInstance = axios.create({
    withCredentials: true
  }) 
let serviceCount = 0
const interceptor = async () => {
  axios.interceptors.request.use(
    (config) => {
      if (serviceCount === 0) {
        dispatch(spinerLog(true))
      }
      const accessToken = localStorage.getItem('token')
      if (accessToken) { 
        config.headers.Authorization = `Bearer ${accessToken}`
      }     
      serviceCount++
      return config
    },
    (error) => {
      serviceCount--
      return Promise.reject(error)
    }
  )
  axios.interceptors.response.use((response) => {
    serviceCount--
    if (serviceCount <= 0) {
    dispatch(spinerLog(false))
    }
    return response
  },
  async (error) => {
    serviceCount--
    if (serviceCount <= 0) {
      dispatch(spinerLog(false))
    }
    const prevRequest = error?.config
    if ((error?.response?.status === 403 || error?.response?.status === 401) && !prevRequest.sent) {
      prevRequest.sent = true
      let redirectUrl = window.location.pathname
      try {  
        let res = await unInterceptedAxiosInstance.post(`${Baseurl}/refreshtoken`).catch(error => console.log('error', error)) 
        localStorage.setItem('token',res.data.accessToken)
        const accessToken = localStorage.getItem('token')
        prevRequest.headers["Authorization"] = `Bearer ${accessToken}`
        return axios(prevRequest)
      } catch (error) {
        dispatch(spinerLog(false))
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)}
export default interceptor